import { createFileRoute } from "@tanstack/react-router";
import { PermissionGuard } from "@/shared/components/PermissionGuard";
import { PERMISSIONS } from "@/shared/config/permissions";
import { OvertimeWatchFeature } from "@/features/overtime-watch/OvertimeWatchFeature";

function OvertimePage() {
  return (
    <PermissionGuard permission={PERMISSIONS.SchedulerShiftsView} fallback={<div className="p-6 text-ink-2">No access.</div>}>
      <OvertimeWatchFeature />
    </PermissionGuard>
  );
}

export const Route = createFileRoute("/scheduler/overtime/")({
  component: OvertimePage,
  staticData: { authorize: true },
});
